import axios from "axios";
import { toast } from 'react-toastify';
import { isObject } from '../../utils/utils';

// SETTINGS

export const settingsSave = (data) => {
    return axios.post(`/chain/api/settings`, { ...data }).then(res => res.data);
}
export const settingsLoad = (filter) => {
    return axios.get(`/chain/api/settings`, { filter }).then(res => res.data);
}

export const getCompanySetting = () => {
    return axios.get(`/api/settings/get`).then(res => res.data);
}

export const getCompanySettingList = () => {
    return axios.get(`/chain/settings/get-lists`).then(res => res.data);
}

export const companySaveDetails = (data) => {
    let formData = new FormData();
    formData.append("contact_details[company_name]", data.company_name);
    formData.append("contact_details[email]", data.email);
    formData.append("contact_details[phone]", data.phone);
    formData.append("contact_details[text]", data.contacts_text);
    formData.append("legal_details[company_name]", data.registered_name);
    formData.append("legal_details[email]", data.accounts_email);
    formData.append("legal_details[registration_number]", data.reg_number);
    formData.append("legal_details[vat_id]", data.vat_id);
    formData.append("legal_details[address]", data.registered_adress);
    formData.append("domain", data.cheqit_domain);

    return axios.post(`/chain/settings/update`, formData, {
        headers: {"Accept": "application/json"},
        onUploadProgress: (e) =>
            console.log(Math.floor((e.loaded * 100) / e.total)),
    })
    .then((res) => res.data);
}

export const companySaveSettings = (data) => {
    const serializedData = {}
    Object.entries(data).forEach(([name, value]) => {
        serializedData[name] = isObject(value) ? value.value: value
    })
    let formData = new FormData();
    formData.append("terms_link", serializedData.terms_conditions);
    formData.append("privacy_link", serializedData.privacy_policy);
    formData.append("country_id", serializedData.country);
    formData.append("language_id", serializedData.language);
    formData.append("timezone_id", serializedData.timezone);
    formData.append("currency_id", serializedData.currency);

    return axios.post(`/chain/settings/update`, formData, {
        headers: {"Accept": "application/json"}})
    .then((res) => res.data);
}

// TAX

export const getTax = (taxId) => {
    return axios.get(`/chain/vats/${taxId}`).then((res) => res.data);
}

export const getAllTax = () => {
    return axios.get(`/chain/vats`).then((res) => res.data);
}

export const getAllRestorants = () => {
    return axios.get(`/chain/api/restaurant/all`).then((res) => res.data);
}

export const taxDelete = (taxId) => {
    return axios.delete(`/chain/vats/${taxId}`).then((res) => res.data);
}

export const taxNewCreate = (action) => {
    const { taxId, values, is_included, isCheckAll, is_enable, selectedIds, all_future_locations } = action;

    let formData = new FormData();
    formData.append("name",values.tax_name);
    formData.append("rate",values.tax_rate);
    formData.append("is_included",is_included);
    formData.append("is_all_restaurants",isCheckAll);
    formData.append("is_enable",is_enable);
    formData.append("all_future_locations",all_future_locations);
    for (let i = 0; i < selectedIds.length; i++) {
        formData.append("restaurant_ids[]",selectedIds[i]);
    }

    if (taxId) {
        const data = {
            "name": values.tax_name,
            "rate": values.tax_rate,
            "is_included": is_included,
            "is_all_restaurants": isCheckAll,
            "is_enable": is_enable,
            "all_future_locations": all_future_locations,
            "restaurant_ids": selectedIds}

        return axios.put(`/chain/vats/${taxId}`, {...data}, {
            headers: {"Content-Type": "application/json"},
            onUploadProgress: (e) =>
                console.log(Math.floor((e.loaded * 100) / e.total)),
        })
        .then((res) => res.data);
    } else {
        return axios.post(`/chain/vats`, formData, {
        headers: {"Content-Type": "application/json"},
        onUploadProgress: (e) =>
            console.log(Math.floor((e.loaded * 100) / e.total)),
        })
        .then((res) => res.data);
    }
};

// PAYMENTS

export const getDefaultPayment = () => {
    return axios.get(`/chain/api/payments`).then((res) => res.data);
}

export const changeDefaultPaymentSystem = (data) => {
    let formData = new FormData();
    formData.append("provider",data.value);
    return axios
        .post(`/chain/api/payments/default`, formData, {
        headers: {"Content-Type": "application/json"},
        onUploadProgress: (e) =>
            console.log(Math.floor((e.loaded * 100) / e.total)),
        })
        .then(res=>toast.success(`Changed to ${data.label}`))
        .then(res => res.data)
        .catch(err=>toast.error("Not changed"))
}

export const stripeSystemDeauthorize = (data) => {
    return axios.post(`/chain/api/payments/deauthorize-stripe/${data.id}`).then(res => res.data);
}

export const yookassaSystemDeauthorize = (data) => {
    return axios.post(`/chain/api/payments/deauthorize-yookassa/${data.id}`).then(res => res.data);
}

export const ameriabankAccountSave = (values) => {
    let formData = new FormData();
    formData.append("account_number",values.account_number);

    return axios.post(`/chain/api/payments/ameriabank`, formData, {
        headers: {"Content-Type": "application/json"},
        onUploadProgress: (e) =>
            console.log(Math.floor((e.loaded * 100) / e.total)),
        })
        .then(res=>toast.success("Ameriabank account number saved!"))
        .then(res => res.data)
        .catch(err=>toast.error("Ameriabank account number not saved!"))
}

export const ameriabankAccountDelete = () => {
    return axios.post(`/chain/api/payments/ameriabank/remove`).then((res) => res.data);
}

// PROFILE

export const getUserProfile = () => {
    return axios.get(`/chain/api/profile/`).then((res) => res.data);
}

export const userProfileUpdate = (data) => {
    let formData = new FormData();
    formData.append("name",data.name);
    formData.append("email",data.email);
    return axios.post(`/chain/api/profile/update-info`, formData, {
        headers: {"Content-Type": "application/json"},
        onUploadProgress: (e) =>
            console.log(Math.floor((e.loaded * 100) / e.total)),
        })
        .then(res=>toast.success("Profile information successfully changed!"))
        .then(res => res.data)
        .catch(err=>toast.error("Profile information was not changed"))
}

export const passwordUpdate = (data) => {
    let formData = new FormData();
    formData.append("password",data.current_password);
    formData.append("new_password",data.new_password);

    return axios.post(`/chain/api/profile/update-password`, formData, {
        headers: {"Content-Type": "application/json"},
        onUploadProgress: (e) =>
            console.log(Math.floor((e.loaded * 100) / e.total)),
        })
        .then(res=>toast.success("Password successfully changed!"))
        .then(res => res.data)
        .catch(err=>toast.error("Password was not changed"))
}

export const browserSessionLogout = (data) => {
    let formData = new FormData();
    formData.append("password",data);
    return axios.post(`/chain/api/profile/log-out-other-browser-sessions`, formData, {
            headers: {"Content-Type": "application/json"},
            onUploadProgress: (e) =>
                console.log(Math.floor((e.loaded * 100) / e.total)),
            })
            .then(res=>toast.success("Browser Sessions Logout success"))
            .then(res => res.data)
            .catch(err=>toast.error("Invalid Password"))
}

export const twoFactorAuthConfirm = (data,is_two_factor_enabled) => {
    let formData = new FormData();
    formData.append("password",data);

    if (is_two_factor_enabled) {
        return axios.post(`/chain/api/profile/disable-two-factor-auth`, formData, {
            headers: {"Content-Type": "application/json"},
            onUploadProgress: (e) =>
                console.log(Math.floor((e.loaded * 100) / e.total)),
            })
            .then(res=>toast.success("2-Factor disabled"))
            .then(res => res.data)
            .catch(err=>toast.error("Invalid Password"))
    } else {
        return axios.post(`/chain/api/profile/enable-two-factor-auth`, formData, {
            headers: {"Content-Type": "application/json"},
            onUploadProgress: (e) =>
                console.log(Math.floor((e.loaded * 100) / e.total)),
            })
            .then(res=>toast.success("2-Factor enabled"))
            .then(res => res.data)
            .catch(err=>toast.error("Invalid Password"))
    }

}

export const regenerateCode = (data) => {
    let formData = new FormData();
    formData.append("password",data);

    return axios.post(`/chain/api/profile/regenerate-recovery-codes` , formData, {
        headers: {"Content-Type": "application/json"},
        onUploadProgress: (e) =>
            console.log(Math.floor((e.loaded * 100) / e.total)),
        })
        .then(res => res.data)
        .catch(err=>toast.error("Invalid Password"))
}

export const deleteAccount = (data) => {
    let formData = new FormData();
    formData.append("password",data);

    return axios.post(`/chain/api/profile/delete-account`, formData, {
        headers: {"Content-Type": "application/json"},
        onUploadProgress: (e) =>
            console.log(Math.floor((e.loaded * 100) / e.total)),
        })
        .then(res => res.data)
}
